export const MeApiPath = {
  CHANGE_MY_PASSWORD: '/api/me/password' // PUT Change My Password
}

export type MeApiPath = (typeof MeApiPath)[keyof typeof MeApiPath]

export interface ChangeMyPasswordVars {
  current_password: string
  new_password: string
}

export interface ChangeMyPasswordResponse {
  ok: boolean
  message: string
}
